import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import {
  AbstractResolver,
  findInheritedRouteData,
} from '@principle-theorem/ng-shared';
import { MarketingCampaign } from '@principle-theorem/principle-core';
import {
  IMarketingCampaign,
  IMarketingCampaignRun,
} from '@principle-theorem/principle-core/interfaces';
import { getDoc$, type WithRef } from '@principle-theorem/shared';
import { type Observable } from 'rxjs';

@Injectable()
export class MarketingCampaignRunResolverService extends AbstractResolver<
  WithRef<IMarketingCampaignRun>
> {
  constructor(router: Router) {
    super(router);
  }

  getItemById(
    uid: string,
    route: ActivatedRouteSnapshot
  ): Observable<WithRef<IMarketingCampaignRun>> {
    const campaign: WithRef<IMarketingCampaign> | undefined =
      findInheritedRouteData(route, 'campaign');
    if (!campaign) {
      throw new Error('Campaign not found');
    }

    return getDoc$(MarketingCampaign.marketingCampaignRunCol(campaign), uid);
  }
}
